module.exports = {"news_list":{"page_title":["Actualités","News"],"title":["<span>Nos dernières</span> actualités","<span>Out last</span> news"],"button_load_more":["Charger plus...","Load more..."],"no_item_found":["Il n'y a aucune actualité pour l'instant.","There is no news for the moment."]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/News/translations/translations_news_list.json
// module id = 685
// module chunks = 0